import React, { useState, useEffect, useMemo } from "react";
import i18n from "@dhis2/d2-i18n";
import Grid from "@material-ui/core/Grid";
import Globalclasses from "../../App.module.css";
import "../../assets/css/customstyles.css";
import { apiServices } from "../../services/apiServices";
import AlertList from "./AlertList";
import { CircularLoader, CenteredContent } from "@dhis2/ui";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Pagination from "@material-ui/lab/Pagination";
import SearchBar from "../../component/searchbar/SearchBar";
import Button from "@material-ui/core/Button";

import _ from "lodash";
import swal from "sweetalert";
import { useTranslation } from "react-i18next";
import { useGlobalSpinnerActionsContext } from "../../context/GlobalSpinnerContext";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
//import { Configuration } from "../../assets/data/config";
import OfflineDb from "../../db";
import "../../assets/css/customstyles.css";
//import "../../assets/css/theme_grey.css";
import "../../assets/css/theme_blue.css";
// import "../../assets/css/theme_green.css";
// import "../../assets/css/theme_red.css";
import FooterMenu from '../../component/layout/FooterMenu'
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const Alerts = () => {
  const { t } = useTranslation();
  const [alertsList, setAlertslist] = useState([]);
  const [alertsListFiltered, setAlertsListFiltered] = useState([]);
  const [input, setInput] = useState("");
  const [searchAllResult, setSearchAllResult] = useState([]);
  // const [sessionUserBoValue, setSessionUserBoValue] = useState(
  //   JSON.parse(sessionStorage.getItem('userBO')) || JSON.parse(localStorage.getItem('userBO'))
  // )
  const [Configuration, setConfiguration] = useState(null);
  const [sessionUserBoValue, setSessionUserBoValue] = React.useState(null);
  const [progarmData, setProgarmData] = useState(null);
  const [viewType, setViweType] = useState("list");
  //const [loading, setGlobalSpinner] = useState(true);
  const classes = useStyles();
  const [alertType, setAlertType] = useState("");
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [searchTabvalue, setSearchTabValue] = React.useState(0);
  const [openAlert, setOpenAlert] = useState(null);

  //pagination code
  //const itemsPerPage = Configuration.pagination.itemsPerPage;
  const [page, setPage] = useState(1);
  const [noOfPages, setNoOfPages] = useState(0);
  const [offset, setoffset] = useState(0);
  const [showLoadMore, setshowLoadMore] = useState(false);


  async function getMetaData() {
    let metadata = await OfflineDb.getDataFromPouchDB("metaData");
    setProgarmData(metadata.data);

    let loginDetails = await OfflineDb.getDataFromPouchDB("loginDetails");
    setSessionUserBoValue(loginDetails.data);

    let configurations = await OfflineDb.getDataFromPouchDB('configurations')
    setConfiguration(configurations.data.configuration)
  }
  useEffect(() => {
    getMetaData();
  }, []);

  useEffect(() => {
    if (sessionUserBoValue != null && progarmData != null && Configuration != null) {
      getAlertList();
    }
  }, [sessionUserBoValue, progarmData, offset, Configuration]);

  useEffect(() => {
    if (alertsListFiltered.length > 0) {
      setNoOfPages(Math.ceil(alertsListFiltered.length / Configuration.pagination.itemsPerPage));
    }
  }, [alertsListFiltered]);

  const groupByAlert = (data) => {
    return data.reduce((acc, item) => {
      const alertType = item.Alert;
      if (!acc[alertType]) {
        acc[alertType] = [];
      }
      acc[alertType].push(item);
      return acc;
    }, {});
  };

  const groupedAlerts = useMemo(() => groupByAlert(alertsListFiltered), [alertsListFiltered]);

  useEffect(() => {
    const firstKey = Object.keys(groupedAlerts)[0];
    if (firstKey) {
      setOpenAlert(firstKey);
    }
  }, [groupedAlerts]);


  const getAlertList = () => {
    setGlobalSpinner(true);
    // const subURL = `alerts/list?ouid=${sessionUserBoValue.organisationUnits[0].id}&programid=${sessionUserBoValue.programs[0]}&pageSize=50&skipPaging=true&paging=true`;
    const subURL = `dashboardIndicator/getAlertData`;
    let payload = {
      "programuid": sessionUserBoValue.programs[0],
      "orguid": sessionUserBoValue.organisationUnits[0].id
    }
    apiServices
      .postAPI(subURL, payload)
      .then((response) => {

        if (response.data.data.length == 0) {
          swal({
            title: t("No record found"),
            button: "Close",
          });
          setGlobalSpinner(false);
          return;
        }
        // console.log('response:', response)
        setAlertslist([...alertsList, ...response.data.data]);
        setAlertsListFiltered([...alertsListFiltered, ...response.data.data]);
        //let databyservice = filterByService(response.data.data[0]?.Service)

        let databyservice = response.data.data
          .filter(group => group.Service === response.data.data[0]?.Service)
          .map(group => ({
            Service: group.Service,
            data: group.data.flatMap(subGroup => subGroup.data)
          }));
        setAlertsListFiltered(databyservice[0]?.data)

        setSearchAllResult([...searchAllResult, ...response.data.data]);
        setGlobalSpinner(false);
      })
      .catch((err) => {
        swal({
          title: t("Error"),
          text: navigator.onLine ? t(err) : t("Data could not be shown in offline mode."),
          icon: "error",
          button: "Close",
        });
        setGlobalSpinner(false);
      });
  };


  const handleViewChange = (event, newValue) => {
    setViweType(newValue);
  };

  const loadMore = () => {
    setoffset(offset + 100);
  };

  const handlePageChange = (event, value) => {
    // console.log("handlePageChange>>", event, value, noOfPages);
    setPage(value);

    if (value == noOfPages) {
      setshowLoadMore(true);
    } else {
      setshowLoadMore(false);
    }
  };

  const loadViewToggleButtons = () => {
    return (
      <div className=" customregistrationtabs regcasetabs ">
        <AppBar position="static">
          <Tabs value={viewType} onChange={handleViewChange}>
            <Tab value="list" label={t("List View")}></Tab>
            <Tab value="card" label={t("Card View")}></Tab>
          </Tabs>
        </AppBar>
      </div>
    );
  };
  const updateInput = (input) => {
    setInput(input);
    let filteredList = [];
    setGlobalSpinner(true);
    if (input && input.length > 3) {
      // searchAllResult.map(function (objectKey, index) {
      //   //objectKey.map(function(data, j) {
      //   if (
      //     objectKey[Configuration.searchbarfielduid]
      //       .toLowerCase()
      //       .indexOf(input.toLowerCase()) > -1
      //   ) {
      //     filteredList.push(objectKey);
      //   }
      //   //})
      // });


      searchAllResult.forEach((serviceBlock) => {
        serviceBlock.data.forEach((alertBlock) => {
          alertBlock.data.forEach((record) => {
            if (
              record.Name.toLowerCase().includes(input.toLowerCase())
            ) {
              filteredList.push({
                Service: serviceBlock.Service,
                Alert: alertBlock.Alert,
                ...record
              });
            }
          });
        });
      });

      //console.log(filteredList)
      // let headerEle = searchAllResult[0]
      // let filterSearchArray = [];
      // filterSearchArray.push(headerEle)
      // filterSearchArray.push(filteredList)
      setAlertsListFiltered([]);
      setTimeout(function () {
        setGlobalSpinner(false);
        setAlertsListFiltered(filteredList);
      }, 500);
    } else {
      if (input.length == 0) {
        // let headerEle = searchAllResult[0]
        // let filterSearchArray = [];
        // filterSearchArray.push(headerEle)
        // filterSearchArray.push(searchAllResult[1])
        setAlertsListFiltered([]);
        setTimeout(function () {
          setGlobalSpinner(false);
          setAlertsListFiltered(searchAllResult);
        }, 1000);
      } else {
        setGlobalSpinner(false);
      }
    }
  };

  const handleSearchTabChange = (event, newValue) => {
    setSearchTabValue(newValue)
    let databyservice = filterByService(alertsList[newValue]?.Service)
    setAlertsListFiltered(databyservice[0]?.data)
    console.log(databyservice, "databyservice")
  }

  const filterByService = (serviceName) => {
    if (alertsList.length > 0) {
      return alertsList
        .filter(group => group.Service === serviceName)
        .map(group => ({
          Service: group.Service,
          data: group.data.flatMap(subGroup => subGroup.data)
        }));
    }
  };

  const filterAlerts = () => {
    const uniqueAlerts = [...new Set(alertsList.map((obj) => obj.alertname))];

    return (
      <div>

        <AppBar position="static" className="alertsTabDiv"
        >
          <Tabs value={searchTabvalue} onChange={handleSearchTabChange} aria-label="simple tabs example" variant="fullWidth">
            {
              alertsList?.map((tabdetails, i) => {
                return <Tab className="whitetext" key={i} style={{ color: '#fff !important' }} label={t(tabdetails.Service)} />

              })
            }
          </Tabs>
        </AppBar>
      </div>
    );
  };

 


  const toggleAccordion = (alertType) => {
    setOpenAlert(openAlert === alertType ? null : alertType);
  };

  return (
    <div className={Globalclasses.container}>
      <main
        style={{
          display: "flex",
          height: "100%",
          width: "100%",
        }}
      >
        {Configuration ?
          <section
            className="searchcustombg searchtabmaindiv searchformcontainer alertspage"
            style={{
              // backgroundColor: "#fff",
              flexGrow: 1,
              padding: 0,
            }}
          >
            <FooterMenu></FooterMenu>
            <Grid item xs={12} sm={12} md={12}>
              <div className="choose_alertdiv">{filterAlerts()}</div>
            </Grid>

            <Grid container spacing={3} className="mb-30px">
              <Grid item xs={8} sm={8} md={8} className="mt-30px"></Grid>
              <Grid item xs={4} sm={4} md={4} className="mt-30px">
                {/* <p className="alertformheading mt-57px">{t("Alerts")}</p> */}
                <SearchBar input={input} setKeyword={updateInput} />
              </Grid>

              <div className="alertsgroupdiv">
                {Object.entries(groupedAlerts).map(([alertType, alerts], idx) => (
                  <div key={idx} style={{ border: "1px solid #ccc", marginBottom: "8px" }}>
                    <div
                      onClick={() => toggleAccordion(alertType)}
                      style={{
                        background: "#f0f0f0",
                        padding: "10px",
                        cursor: "pointer",
                        fontWeight: "bold",
                        color: "#295fa3"
                      }}
                    >
                      {alertType} ({alerts.length})
                    </div>
                    {openAlert === alertType && (
                      <div style={{ padding: "10px" }}>
                        {alerts
                          .slice(
                            (page - 1) * Configuration.pagination.itemsPerPage,
                            page * Configuration.pagination.itemsPerPage
                          )
                          .map((alert, index) =>
                            progarmData ? (
                              <AlertList
                                keyindex={index}
                                alertdata={alert}
                                progarmData={progarmData}
                                viewType={viewType}
                              />
                            ) : (
                              <></>
                            )
                          )}
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <Pagination
                count={noOfPages}
                page={page}
                onChange={handlePageChange}
                defaultPage={1}
                //color="primary"
                size="large"
                showFirstButton
                showLastButton
                variant="outlined"
                shape="rounded"
              />

              {showLoadMore && (
                <Button
                  variant="contained"
                  color="primary"
                  className="btn-load-more"
                  onClick={() => loadMore()}
                >
                  Load More
                </Button>
              )}
            </Grid>
          </section>
          : <></>
        }
      </main>
    </div>
  );
};

export default Alerts;
